import {
	gsap
} from "gsap/dist/gsap";
import {
	ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
import api from "../api";
import Toastify from 'toastify-js'
const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
	paused: false, // default is false
	smoothChildTiming: true,
});
headerBarAnimate
	.fromTo(
	headerBar, {
		opacity: 0,
		}, {
			opacity: 1,
			duration: 0.5,
		},
	 "<.2")
	.fromTo(headerBar, {
		scale: 0.95
	}, {
		scale: 1,
		duration: 1
	}, "<.1");


document.addEventListener('DOMContentLoaded', function (e) {
    let body = document.querySelector("body");
    const menuitem = document.querySelector('.orely-header__desktop #menu-item-1328');
    let gallerySceneWrapper = document.querySelector('.freebies-scene-gallery');
    let gallerySceneDesktop = null;
    let gallerySceneMobile = null;
    let bottomEffect = null;
    let buttonLoadMore = null;
    let sceneGalleryCount = 0;
    let sceneImageIndex = 0;
    let sc_width = screen.width;


    if (preLoaderEl) {
        setTimeout(function () {
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
              });
            preLoaderEl.classList.add('hide');
            mainContent.classList.remove('overflow-hidden');
            mainContent.classList.remove('opacity-0');
            mainContent.classList.add('opacity-100');
        }, 1300)
    }

    if (menuitem) {
        menuitem.classList.add('active');
    }

	setTimeout(function(){
        headerBarAnimate.play();

    let timelineResourcesblog = gsap.timeline({
        paused: true, // default is false
        defaults: { // children inherit these defaults
            duration: 1,
            ease: "power2.out"
        },
        smoothChildTiming: true,
    });
    timelineResourcesblog
        .fromTo('.entry-header-post-meta h1', {
            scale: 0.7,
            y: '10px',
            opacity: 0,
        }, {
            scale: 1,
            opacity: 1,
            y: '0px'
        }, '<.1')
        .fromTo('.entry-header-post-meta  .header-post-meta', {
            scale: 0.7,
            opacity: 0,
        }, {
            scale: 1,
            opacity: 1
        }, '<.1')
        .fromTo('.social-share-wrapper button', {
            y: '20px'
        }, {
            opacity: 1,
            y: '0px',
            duration: .3,
            stagger: .1
        }, '<.1')
        .play();

        gsap.fromTo(
            '.img-desktop-wrapper img',
            {
                opacity: 0,
                y: '20px'
            },
            {
                opacity: 1,
                y: '0px',
                duration: .5
            }
        , '<.2')
        .play();

        const freebiesContent = document.querySelector('.freebies-content');
        let contetnEl = [];
        let contentAnimate = gsap.timeline({
            paused: true, // Atur menjadi true agar animasi tidak dijalankan secara otomatis
            smoothChildTiming: true,
        }); 
        freebiesContent.childNodes.forEach(content => {
            content.childNodes.forEach(el => {
                contetnEl.push(el.parentElement);
                
            });
        });
        console.log(contetnEl);
        contetnEl.forEach(element => {
            contentAnimate = gsap.timeline({
                paused: false, // Atur menjadi true agar animasi tidak dijalankan secara otomatis
                smoothChildTiming: true,
                scrollTrigger: {
                    trigger: element,
                    start: 'top 95%',
                    end: 'bottom center'
                }
            });
            contentAnimate.fromTo(element, {
                opacity: 0,
                y: '40px',
            }, {
                y: '0px',
                opacity: 1,
                duration: .5,
                delay: .1
            });

            //  const observer = new IntersectionObserver((entries, observer) => {
            //     entries.forEach(entry => {
            //         if (entry.isIntersecting) {
            //             contentAnimate.play(); // Jalankan animasi jika card masuk ke viewport
            //             observer.unobserve(entry.target); // Berhenti mengamati card setelah animasi dijalankan
            //         }
            //     });
            // });

            // observer.observe(element);
        });

    },1300);

    if (gallerySceneWrapper) {
        gallerySceneDesktop = gallerySceneWrapper.querySelectorAll('img.scene-item.scene-desktop');
        gallerySceneMobile = gallerySceneWrapper.querySelectorAll('img.scene-item.scene-mobile');
        bottomEffect = document.querySelector('.gallery-bottom-shadow');
        buttonLoadMore = document.querySelector('.scene-more-button');

        if (buttonLoadMore) {
            buttonLoadMore.addEventListener('click', function (e) {
                sceneImageIndex += 1;

                if (sc_width < 600) {
                    gallerySceneMobile.forEach((el, index) => {
                        gallerySceneMobile[index].classList.add('scene-active');
                    });
                    buttonLoadMore.classList.add('hidden');
                    bottomEffect.classList.add('hidden');
                } else {
                    gallerySceneDesktop.forEach((el, index) => {
                        el.classList.add('scene-active');
                    });
                    buttonLoadMore.classList.add('hidden');
                    bottomEffect.classList.add('hidden');
                }

                if (sceneImageIndex + 1 == sceneGalleryCount) {
                    
                }
            })
        }

        if (sc_width < 600) {
            if (gallerySceneMobile.length > 0) {
                gallerySceneMobile.forEach(element => {
                    element.classList.add('scene-show')
                });
                sceneGalleryCount = gallerySceneMobile.length;
                sceneImageIndex = 0;
                gallerySceneMobile[0].classList.add('scene-active');
            }
        } else {
            if (gallerySceneDesktop.length > 0) {
                gallerySceneDesktop.forEach(element => {
                    element.classList.add('scene-show')
                });
                sceneGalleryCount = gallerySceneDesktop.length;
                sceneImageIndex = 0;
                gallerySceneDesktop[0].classList.add('scene-active');
            }
        }

        if (sceneImageIndex < sceneGalleryCount -1) {
            buttonLoadMore.classList.remove('hidden');
            bottomEffect.classList.remove('hidden');
        }
    }

    let buttonDownloadResource = document.querySelector("button.button-download-attachment");
    let elementSubmitForm = document.querySelector(".popup-submit-form");
    let modalClose = document.querySelector(".modal-close");
    let buttonModalClose = document.querySelector(".button-modal-close");
    let ajaxButtonBack = document.querySelector('.ajax-result-btn-back');
    let ajaxButtonClose = document.querySelector('.ajax-result-btn-close');
    let elementResultSubmit = document.querySelector(".popup-result-submit");

    
    if (modalClose) {
        modalClose.addEventListener('click',resourceModalClose);
    }
    if (buttonModalClose) {
        buttonModalClose.addEventListener('click',resourceModalClose);
    }

    if (ajaxButtonBack) {
        ajaxButtonBack.addEventListener('click',resourceModalReustlClose);
    }
    if (ajaxButtonClose) {
        ajaxButtonClose.addEventListener('click',resourceModalReustlClose);
    }

    if (buttonDownloadResource) {
        buttonDownloadResource.addEventListener("click", function(e){
            body.classList.add('overflow-hidden');
            elementSubmitForm.classList.add('show-popup');
            elementSubmitForm.classList.remove('hidden-popup');
        })
    }

    function resourceModalClose(){
        elementSubmitForm.classList.remove('show-popup');
        elementSubmitForm.classList.add('hidden-popup');
        body.classList.remove("overflow-hidden");
    }

    function resourceModalReustlClose(){
        elementResultSubmit.classList.remove('show-popup');
        elementResultSubmit.classList.add('hidden-popup');
        body.classList.remove("overflow-hidden");
    }
    
    let inputPostID = document.getElementById("resource-post");
    let inputResource = document.getElementById("resource-url");
    let inputEmail = document.getElementById("resource-email");
    let submitResource = document.querySelector("button.submit-resources");
    let successIcon = document.querySelector('.success-icon-wrapper');

    if (submitResource) {
        submitResource.addEventListener('click', function(){
            let formData = new FormData();
            formData.append( 'email', inputEmail.value );
            formData.append( 'postID', inputPostID.value );
            formData.append( 'resource', inputResource.value );
            formData.append('path',window.location.href);
            formData.append( 'action', 'freebiesAjaxDownload' );
            formData.append( 'security', document.getElementById( 'security' ).value );
            
            api.Freebies.actionSubmited(formData).then((result)=>{
                let jsonData = JSON.parse(result.data.toString().replace("}0","}"));
                if (jsonData) {
                    if (jsonData.status !== 'success') {
                        successIcon.classList.add('hidden');   
                    }
                    elementResultSubmit.querySelector('.result-title').outerHTML = '<p class="heading-3 font-semibold text-center text-[#020B1F] pt-[21px] pb-3 result-title">'+jsonData.title+'</p>' ;
                    elementResultSubmit.querySelector('.result-message').outerHTML = '<p class="text-center font-default text-[16px] leading-[28.8px] tracking-[0.16px] pb-10 result-message">'+jsonData.message+'</p>' ;
                    elementSubmitForm.classList.remove('show-popup');
                    elementSubmitForm.classList.add('hidden-popup');
                    setTimeout(function(){
                        elementResultSubmit.classList.remove('hidden-popup');
                        elementResultSubmit.classList.add('show-popup');
                    },10)
                }


                // title
                // message
            })
        })
    }

    
// Copy link 
function copyPageLink() {
    var currentPageLink = window.location.href;
    
    var tempInput = document.createElement("input");
    tempInput.value = currentPageLink;
    document.body.appendChild(tempInput);

    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    Toastify({
        text: "Link copied to clipboard.",
        duration: 3000, // Durasi dalam milidetik (misalnya 3000 ms = 3 detik)
        gravity: "bottom", // Letak posisi toast (top, bottom, left, right)
        position: "center", // Posisi toast (top, center, bottom, left, right)
        backgroundColor: "#0F39A6", // Warna latar belakang
        className: "toastify-copylink", // Kelas CSS kustom untuk gaya tambahan
    }).showToast();
}


let copylink = document.querySelector('.share-button--link')
copylink.addEventListener('click',copyPageLink)


// // share to facebook
function shareOnFacebook() {
    var currentPageLink = window.location.href;
    var articleUrl = currentPageLink;

    // Membuka dialog share Facebook dengan URL artikel
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(articleUrl), "_blank");
}

// Event listener untuk tombol "Share on Facebook"
var facebookShareButton = document.querySelector(".share-button--facebook");
facebookShareButton.addEventListener("click", shareOnFacebook);

function shareToTwitter() {
    var currentPageLink = window.location.href;
    var pageTitle = document.title;

    // Buat tautan berbagi Twitter dengan URL halaman saat ini dan judul halaman sebagai teks pra-pengisian
    var twitterShareLink = 'https://twitter.com/intent/tweet' +
        '?text=' + encodeURIComponent(pageTitle) +
        '&url=' + encodeURIComponent(currentPageLink);

    // Buka tautan berbagi Twitter di jendela baru
    window.open(twitterShareLink, '_blank');
}
var twitterShareButton = document.querySelector(".share-button--twitter");
twitterShareButton.addEventListener("click", shareToTwitter);

function shareToLinkedIn() {
    var currentPageLink = window.location.href;
    var pageTitle = document.title;

    // Buat tautan berbagi LinkedIn dengan URL halaman saat ini dan judul halaman sebagai teks pra-pengisian
    var linkedinShareLink = 'https://www.linkedin.com/shareArticle' +
        '?mini=true' +
        '&url=' + encodeURIComponent(currentPageLink) +
        '&title=' + encodeURIComponent(pageTitle);

    // Buka tautan berbagi LinkedIn di jendela baru
    window.open(linkedinShareLink, '_blank');
}
var linkedInShareButton = document.querySelector(".share-button--linkedin");
linkedInShareButton.addEventListener("click", shareToLinkedIn);
})